import { NavigationHelper, useAppDispatch } from '@common';
import { isIncludeOrEqual } from '@common';
import { Errors } from '@common';
import { ISignupForm } from '@pages/Authentication/entities/interface';
import { useSignupMutation } from '@pages/Authentication/services/AuthService';
import { updateAuthState } from '@pages/Authentication/store';
import type { FormInstance } from 'antd';

export function useSignupForm() {
    const dispatch = useAppDispatch();
    const [signup, { isLoading }] = useSignupMutation();

    async function onFinish(values: ISignupForm, form: FormInstance<ISignupForm>) {
        try {
            const response = await signup(values).unwrap();

            if (response.authToken) {
                dispatch(updateAuthState(response));
                NavigationHelper.Home().navigate();

                sessionStorage.setItem('authToken', response.authToken);
            }
        } catch (error: any) {
            if (isIncludeOrEqual(error?.data?.message, [Errors.emailExists, Errors.userNotVerified], true)) {
                form.setFields([
                    {
                        name: 'email',
                        errors: [error?.data?.message],
                    },
                ]);
            } else if (isIncludeOrEqual(error?.data?.message, Errors.userNameExists, true)) {
                form.setFields([
                    {
                        name: 'userName',
                        errors: [error?.data?.message],
                    },
                ]);
            }
        }
    }
    return { onFinish, isLoading };
}
